import React from 'react';
import { Helmet } from 'react-helmet';
import './apiPages.css';

import Footer from '../Footer';
import HeroComponentv2 from '../productComponent/hero/HeroComponentv2';
import MultiPanelCards from '../productComponent/benefits/MultiPanelCards';
import ThreePanelCards from '../productComponent/benefits/ThreePanelCards';
import CaseStudyComponent from '../productComponent/customer/CaseStudyComponent';

// Import images
import api_hero from "../../assets/images/api/api-header.jpg";
import Llama_Watching from "../../assets/images/unauth/llama-watching-small.png";
import Llama_Reading from "../../assets/images/unauth/llama-reading-clay.png";
import llama_surfing_thumbnail from '../../assets/images/thumbnail/llama-bump-thumbnail.jpg';

// Import images for MultiPanelCards
import org_pannel1 from "../../assets/images/api/api-org-panel-1.jpg";
import org_pannel2 from "../../assets/images/api/api-org-panel-2.jpg";
import org_pannel3 from "../../assets/images/api/api-org-panel-3.jpg";

// Import images for ThreePanelCards
import Pannel1 from "../../assets/images/api/api-panel-1.jpg";
import Pannel2 from "../../assets/images/api/api-panel-2.jpg";
import Pannel3 from "../../assets/images/api/api-panel-3.jpg";

const EnterpriseAPI = () => {

  const heroData = {
    title: 'Enterprise Video Intelligence',
    subtitle:
      'Empower your organization with AI that transforms raw video into strategic insights, seamlessly integrating into your enterprise for secure, scalable processing.',
    buttonText: 'Contact Sales Team',
    imgSrc: api_hero,
    buttonLink: 'https://forms.gle/syyzvT25DsQ6yfZq5',
    llamaWatching: Llama_Reading,
    llamaReading: Llama_Watching
  };

  const caseStudyData = {
    leftImage: llama_surfing_thumbnail,
    title: 'Transform Your Enterprise',
    subtitle:
      'Leverage our robust API to convert voluminous video data into actionable intelligence that drives operational excellence and informed decision-making.',
    buttonText: 'Contact Sales Team',
    buttonLink: 'https://forms.gle/syyzvT25DsQ6yfZq5',
    stats: [
      { metrics: '5+', description: 'Enterprise-ready API endpoints' },
      { metrics: 'AI-Driven', description: 'Transforming video data into strategic assets' },
      { metrics: 'Optimized', description: 'For high-volume, mission-critical applications' },
    ],
  };

  const multiPanelData = {
    headerText: "Bumpups inside your organization",
    freeButtonText: "Contact Sales Team →",
    freeButtonLink: "https://forms.gle/syyzvT25DsQ6yfZq5",
    buttons: [
      {
        title: "Bumpups in your tech stack",
        subtext:
          "Integrate Bumpups into your existing tech stack to analyze video content and unlock actionable insights.",
        image: org_pannel1,
      },
      {
        title: "Bumpups in your team",
        subtext:
          "Empower your team with smart video intelligence, transforming raw footage into actionable assets.",
        image: org_pannel2,
      },
      {
        title: "Pricing",
        subtext:
          "Discussed based on your organization's needs to ensure a tailored solution.",
        image: org_pannel3,
      },
    ]
  };

  const threePanelData = {
    header: "Enterprise-Grade Video Insights",
    subtext: "Our API is engineered for the demanding needs of modern enterprises. Integrate deep video analytics effortlessly, and transform raw footage into actionable intelligence that drives performance and innovation.",
    buttonText: "Read API Documentation",
    buttonLink: "https://docs.bumpups.com/docs/getting-started",
    cards: [
      {
        image: Pannel3,
        header: "Scalable Integration",
        subtext: "Our solutions are built to expand with your enterprise, ensuring seamless performance as your needs grow."
      },
      {
        image: Pannel1,
        header: "Rapid Deployment",
        subtext: "Integrate our API quickly and efficiently, reducing time-to-value while maintaining robust security standards."
      },
      {
        image: Pannel2,
        header: "Actionable Intelligence",
        subtext: "Transform vast video content into insightful, strategic data that informs enterprise-level decisions."
      }
    ]
  };

  return (
    <div className="api-main-container">
      <Helmet>
        <title>Bumpups for enterprise teams | Bumpups.com</title>
        <meta
          name="description"
          content="Elevate your enterprise's video processing with Bumpups' AI-powered platform. Seamlessly integrate diverse video sources, transform raw content into strategic insights, and scale securely."
        />
      </Helmet>
      <HeroComponentv2 data={heroData} />
      <MultiPanelCards {...multiPanelData} />
      <ThreePanelCards data={threePanelData} />
      <CaseStudyComponent caseStudyData={caseStudyData} />
      <Footer />
    </div>
  );
};

export default EnterpriseAPI;
